import { MISSING_UNIQUE_NAME } from '../../../constants/category_display'

export const getLocalizedCategoryName = (category, langID) =>
  category?.category_values?.find((v) => v.language_id === langID)?.value ||
  category?.category_values?.[0]?.value ||
  null

export const getCategoryTitle = (category, langID) => {
  if (['warning-slates', 'featured-content'].includes(category.type)) {
    return getLocalizedCategoryName(category, langID) || ''
  }
  return getLocalizedCategoryName(category, langID) || category.external_unique_name || MISSING_UNIQUE_NAME
}

export const getSectionName = (section, langID) =>
  getLocalizedCategoryName(section, langID) || section.external_unique_name || MISSING_UNIQUE_NAME

export const getSectionFieldLabel = (section, langID) => `Within the ${getSectionName(section, langID)} section`

export const mapAssignedCategory = (category, assignedCategories, langID) => {
  const assigned = assignedCategories.find((entry) => entry.id === category.id)
  if (!assigned) return null
  return { label: getCategoryTitle(assigned, langID), value: assigned.id }
}
